import { render } from "./SimpleStepBar.vue?vue&type=template&id=888bde2a"
import script from "./SimpleStepBar.vue?vue&type=script&lang=js"
export * from "./SimpleStepBar.vue?vue&type=script&lang=js"
script.render = render

export default script